module.exports = __webpack_public_path__ + "static/img/walking-man-blue.4ffcc15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/walking-man-blue.svg
// module id = OMBx
// module chunks = 82